import { render, staticRenderFns } from "./RCheckbox.vue?vue&type=template&id=4eeead51&scoped=true"
import script from "./RCheckbox.vue?vue&type=script&lang=js"
export * from "./RCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RCheckbox.vue?vue&type=style&index=0&id=4eeead51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeead51",
  null
  
)

export default component.exports